import type { FunctionComponent } from 'react'
import React from 'react'
import { Heading, Picture, TypographyV2 as Typography } from '@which/seatbelt'

import classnames from 'classnames'

import { Link } from '../Link'
import styles from './StandardCard.module.scss'

export const StandardCard: FunctionComponent<Props> = ({
  body = '',
  className,
  imageAlt,
  imageSrc,
  label,
  linkText = '',
  linkUrl = '',
  standFirst,
  title,
  style,
  inlineImage,
}) => {
  return (
    <div
      key={title}
      className={classnames(className, {
        [styles.card]: style !== 'article',
        [styles.cardArticle]: style === 'article',
        [styles.cardHorizontal]: inlineImage,
      })}
      data-testid="standard-card"
    >
      <Picture
        alt={imageAlt}
        lazyLoad={false}
        src={imageSrc}
        className={classnames({
          [styles.cardArticleImage]: style === 'article',
        })}
      />
      <div
        className={classnames({
          [styles.cardArticleContent]: style === 'article',
          [styles.cardHorizontalContent]: inlineImage,
        })}
      >
        {label && (
          <div className={styles.cardLabel}>
            <Typography tag="span" textStyle="sb-text-body-small-regular">
              {label}
            </Typography>
          </div>
        )}
        <Heading heading={title} headingTag="h3" headingType="small" />
        {standFirst && (
          <Typography textStyle="sb-text-body-default-regular">{standFirst}</Typography>
        )}
        {body && (
          <div
            data-testid="standard-card-body-text"
            dangerouslySetInnerHTML={{ __html: body }}
            className={classnames(styles.cardBody, {
              [styles.cardHorizontalContentBody]: inlineImage,
            })}
          />
        )}
        {linkText && linkUrl && <Link href={linkUrl}>{linkText}</Link>}
      </div>
    </div>
  )
}

type Props = {
  body?: string
  className?: string
  imageAlt: string
  imageSrc: string
  label?: string
  linkText?: string
  linkUrl?: string
  standFirst?: string
  style?: string
  title: string
  inlineImage?: boolean
}
